import {observer} from 'mobx-react-lite'
import React, {useEffect, useRef} from 'react'
import tw from 'tailwind-styled-components'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'
import {startOfDay} from '@components/timeline-new/utils'
import {updateRef} from '@containers/element-utils'
import {Swimlanes} from './swimlanes'

const TwGraph = tw.div`
  relative
  isolate
  flex
  flex-col
  min-h-0
  min-w-0
`

const TwSwimlanes = tw(Swimlanes)`
  flex-1
  w-full
`

export interface GraphProps {
  className?: string
}

export const Graph = observer((props: GraphProps) => {
  const {className} = props
  const [, store] = useTimelineNewStore()

  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const fn = (e: WheelEvent) => store.graphHelper.graphScrollY(e)
    ref.current?.addEventListener('wheel', fn, {passive: true})
    return () => ref.current?.removeEventListener('wheel', fn, {})
  }, [ref, store])

  return (
    <TwGraph
      ref={el => {
        updateRef(el, store.setGraphEl)
        updateRef(el, ref)
      }}
      className={className}
    >
      <TwSwimlanes />
      <Now />
    </TwGraph>
  )
})

const TwNowLine = tw.div`
  absolute
  top-0
  bottom-0
  w-1
  bg-normal-red
  opacity-50
  pointer-events-none
`

const TwNowCircle = tw.div`
  absolute
  w-[9px]
  h-[9px]
  rounded-full
  bg-normal-red
  origin-center
  top-0
  pointer-events-none
`

const Now = observer(() => {
  const [, store] = useTimelineNewStore()

  const date = startOfDay(new Date())
  const left = store.timeToPosition(date.getTime())

  return (
    <>
      <TwNowLine style={{transform: `translateX(${left}px)`}} />
      <TwNowCircle
        style={{
          transform: `translateX(${left}px) translateX(-50%) translateY(-50%)`
        }}
      />
    </>
  )
})
